import { replaceNull } from '@youkeeps/shared';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useMarketplaceToken = () => {
  const [searchParams] = useSearchParams();
  // Query string decoding turns a '+' into a space, which corrupts the base64 marketplace token.
  const token = useMemo(() => replaceNull(searchParams.get('token'))?.replaceAll(' ', '+'), [searchParams]);
  return token;
};
